
import { NetSuiteProductsDropdown } from 'apps/app/src/pages/plans/CreatePlanPage/create-plan-page-components/FixedChargeEditDrawer/fixed-charge-edit-drawer-components/components/NetSuiteProductsDropdown';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ConfigurationViewPropertiesBlock } from '../../ConfigurationViewPropertiesBlock';
import { NET_SUITE_CONFIGURATION_SECTIONS } from '../net-suite-configuration-consts/net-suite-configuration-sections';
import type { NetSuiteIntegrationConfigurationWithSections } from '../net-suite-configuration-types/net-suite-configuration-type';

const FIELD_NAME = 'defaultProduct';

export const ProductsConfigurationSection: React.FC = () => {
  const { watch, resetField, control } = useFormContext<NetSuiteIntegrationConfigurationWithSections>();

  const currenctSection = watch('sectionToEdit');
  const isInEditMode = currenctSection === NET_SUITE_CONFIGURATION_SECTIONS.products;

  const handleCancelClick = () => {
    resetField('defaultProduct');
  };

  return (
    <ConfigurationViewPropertiesBlock<NetSuiteIntegrationConfigurationWithSections>
      title='Products'
      showEditButton
      onCancel={handleCancelClick}
      fieldValue={NET_SUITE_CONFIGURATION_SECTIONS.products}
      field='sectionToEdit'
    >
      <div className='flex w-1/5 flex-col border-0 pr-6'>
        <NetSuiteProductsDropdown
          control={control}
          fieldPath={FIELD_NAME}
          showDropdown={isInEditMode}
        />
      </div>
    </ConfigurationViewPropertiesBlock>
  );
};